import { jsxs as a, jsx as o } from "react/jsx-runtime";
import { Container as m, Content as p } from "./styles.js";
import { IconButton as s } from "../IconButton/IconButton.js";
import { Close as l } from "../../foundations/icons/Close.js";
const c = ({ status: t = "warning", align: r = "top", onClose: n, children: e, ...i }) => /* @__PURE__ */ a(m, { $alignItems: r, $styleStatus: t, ...i, children: [
  /* @__PURE__ */ o(p, { children: e }),
  typeof n == "function" && /* @__PURE__ */ o(s, { ariaLabel: "Close", onClick: n, children: /* @__PURE__ */ o(l, {}) })
] });
c.displayName = "TopBanner";
export {
  c as TopBanner
};
//# sourceMappingURL=TopBanner.js.map
